import { useEffect, useState } from 'react';
import { css } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import ProductLayout from '../../common/main-layout/ProductLayout';
import { CABIN_UPGRADE } from '../../products';
import { parseJsonProp } from '../../common/utils/productCardProps';
import { getCabinUpgradeProduct, getSegmentUpgrade, minimumSegmentUpgradeTotalPrice, selectedSegmentUpgradeTotalPrice, validateCabinUpgradeAvailabilityTexts } from '../utils/utils';
import { useProductData } from '../../common/hook/useProductData';
import CabinUpgradeDrawer from './drawer/CabinUpgradeDrawer';
import ChangeUpgradeSelection from './ChangeUpgradeSelection';
import CabinUpgradeAvailabilityCard from './CabinUpgradeAvailabilityCard';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  name: PRODUCT_NAME,
  id: PRODUCT_ID
} = CABIN_UPGRADE;
const generalTexts = {
  abstractContent: 'cabinUpgradeAbstract',
  additionalInformation: 'cabinUpgradeAdditionalInformation',
  availabilityGeneralTexts: 'cabinUpgradeGeneralPurpose',
  fromPriceLabel: 'Products.Price.Label.From',
  destinationLabel: 'Searchform.Destination.Label',
  readMoreContent: 'cabinUpgradeReadMoreModalContent',
  title: 'cabinUpgradeTitle',
  totalPriceLabel: 'Products.Price.Label.Total',
  upSell: 'cabinUpgradeUpsell'
};
const readMoreGrid = css`
  display: grid;

  .text {
    grid-area: 2 / 1 / 3 / 2;
  }

  .children {
    display: grid;
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 16px;
    padding-inline: 16px;
  }
`;
const CabinUpgrade = _ref => {
  let {
    form,
    isPostBooking,
    isProductSelected,
    isUpgradeSaved,
    order,
    productPosition,
    selectedUpgrades,
    unselectedUpgrades,
    updateSelectedCabinUpgrades
  } = _ref;
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const texts = generalTexts || {};
  const product = getCabinUpgradeProduct(PRODUCT_ID, order);
  const {
    productData,
    rootElement,
    translation: {
      availabilityGeneralTexts,
      destinationLabel,
      fromPriceLabel,
      totalPriceLabel
    }
  } = useProductData({
    form,
    isSelected: isUpgradeSaved,
    order: order,
    productId: PRODUCT_ID,
    productName: PRODUCT_NAME,
    productPosition,
    texts
  });
  useEffect(() => {
    if (isProductSelected) {
      setIsDrawerOpen(isProductSelected);
    }
  }, [isProductSelected]);
  const availabilityTexts = parseJsonProp(availabilityGeneralTexts);
  const segmentUpgradeList = product ? getSegmentUpgrade(product, order) : [];
  const hasAvailabilityTexts = availabilityTexts && validateCabinUpgradeAvailabilityTexts(availabilityTexts);
  const shouldHideCabinUpgrade = !productData || !isPostBooking || !hasAvailabilityTexts || !(segmentUpgradeList !== null && segmentUpgradeList !== void 0 && segmentUpgradeList.length);
  if (shouldHideCabinUpgrade) {
    return null;
  }
  const priceRaw = isUpgradeSaved ? selectedSegmentUpgradeTotalPrice(selectedUpgrades) : minimumSegmentUpgradeTotalPrice(segmentUpgradeList);
  const updatedProductData = {
    ...productData,
    priceRaw,
    price: priceUtils.formatPrice(priceRaw),
    priceLabel: isUpgradeSaved ? totalPriceLabel : fromPriceLabel
  };
  return /*#__PURE__*/_jsxs(ProductLayout, {
    productData: updatedProductData,
    ref: rootElement,
    children: [/*#__PURE__*/_jsx(ProductLayout.ReadMore, {
      customGrid: readMoreGrid,
      children: /*#__PURE__*/_jsx(CabinUpgradeAvailabilityCard, {
        availabilityTexts: {
          ...availabilityTexts,
          destinationLabel
        },
        segmentUpgradeList: segmentUpgradeList
      })
    }), /*#__PURE__*/_jsx(CabinUpgradeDrawer, {
      availabilityTexts: availabilityTexts,
      isOpen: isDrawerOpen,
      isProductSelected: isProductSelected,
      isUpgradeSaved: isUpgradeSaved,
      segmentUpgradeList: segmentUpgradeList,
      selectedUpgrades: selectedUpgrades,
      setIsDrawerOpen: setIsDrawerOpen,
      unselectedUpgrades: unselectedUpgrades,
      updateSelectedCabinUpgrades: updateSelectedCabinUpgrades
    }), isUpgradeSaved && /*#__PURE__*/_jsx(ChangeUpgradeSelection, {
      label: availabilityTexts.availabilityCard.changeUpgradeLabel,
      setIsDrawerOpen: setIsDrawerOpen
    })]
  });
};
export default CabinUpgrade;
//# sourceMappingURL=CabinUpgrade.js.map